import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Button = styled(motion.button)`
  background-color: ${props => props.active === false ? '#b4b4b4' : 'var(--red)'};
  color: #fff;
  text-transform: uppercase;
  border-radius: 5px;
  border: ${( { error } ) => error ? '1px solid var(--red)' : 'none'};
  padding: 0.75rem 2rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:disabled {
    background-color: #b4b4b4;
  }

  &.outlined {
    background-color: transparent;
    border: 2px solid ${props => props.active === false ? '#b4b4b4' : 'var(--red)'};
    color: ${props => props.active === false ? '#b4b4b4' : 'var(--red)'};
  }
`